import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        home: "Home",
        lottery_registration: "Lucky Draw Registration",
        gallery: "Gallery",
        shop_now: "Shop Now",
        legal: "Legal",
        terms: "Terms & Conditions",
        dashboard: "Dashboard",
        menu: "Menu",

        // Terms Page
        terms_title: "Terms & Conditions",
        terms_list: [
          "You will receive a receipt based on the blanket purchased and the included gifts.",
          "Delivery will be completed within 7 to 10 days as stated.",
          "Lucky draw items will be distributed according to the given date.",
          "This scheme is open only to Indian residents.",
          "Only one prize per person / mobile number / address.",
          "Prizes cannot be exchanged for cash or other items.",
          "Organizers reserve the right to change or cancel the prize.",
          "KYC documents and form submission are mandatory to claim the prize.",
          "Winners are selected randomly via lucky draw.",
          "Prize must be claimed within the specified time (e.g., 10 days).",
          "Travel or collection costs must be borne by the winner.",
          "All payments must be made online only through the company’s official QR code. Payments should not be made to any individual or personal account. If payment is made to any other account and the amount does not reach the company, the company will not be responsible.",          "Organizers reserve the right to deny participation or cancel the scheme at any time."
        ],
        more_info: "For more information visit",

        our_gallery: "Our Gallery",

        // Lottery form
        receiver_name: "Receiver Name",
        receiver_coupon_no: "Coupon Number",
        receiver_address: "Receiver Address",
        receiver_mobile: "Receiver Mobile",
        receiver_aadhaar: "Receiver Aadhaar",
        giver_name: "Giver Name",
        giver_mobile: "Giver Mobile",
        giver_address: "Giver Address",
        payment_cash: "Payment Cash",
        payment_online: "Payment Online",
        submit: "Submit",
        registration_success: "Registration submitted successfully!",
        registration_failed: "Registration failed",
      },
    },

    mr: {
      translation: {
        home: "मुख्य पृष्ठ",
        lottery_registration: "लकी ड्रॉ नोंदणी",
        gallery: "गॅलरी",
        shop_now: "शॉप नाऊ",
        legal: "कायदेशीर",
        terms: "नियम व अटी",
        dashboard: "डॅशबोर्ड",
        menu: "मेन्यू",

        // Terms Page
        terms_title: "नियम व अटी",
        terms_list: [
          "आपण खरेदी केलेल्या ब्लँकेट व भेटवस्तूच्या आधारे आपल्याला रसीद मिळेल.",
          "खरेदी केलेल्या वस्तूंची ७ ते १० दिवसात डिलिव्हरी केली जाईल.",
          "लकी ड्रॉच्या वस्तू दिलेल्या तारखेनुसार दिल्या जातील.",
          "ही योजना फक्त भारतीय रहिवाशांसाठी खुली आहे.",
          "एका व्यक्ती/मोबाईल/पत्त्यावर केवळ एकच बक्षीस मिळेल.",
          "बक्षीस रोख किंवा इतर वस्तूमध्ये बदलले जाणार नाही.",
          "आयोजकांना बक्षीस बदलण्याचा किंवा रद्द करण्याचा अधिकार आहे.",
          "बक्षीस मिळवण्यासाठी KYC कागदपत्रे व फॉर्म आवश्यक आहे.",
          "विजेते लकी ड्रॉ पद्धतीने निवडले जातील.",
          "बक्षीस दाव्यासाठी दिलेल्या मुदतीत दावा करणे आवश्यक आहे.",
          "बक्षीस घेण्यासाठी लागणारा खर्च विजेत्याने करावा.",
          "सर्व नोंदणीकर्त्यांनी पेमेंट फक्त कंपनीच्या अधिकृत QR कोडवरच ऑनलाइन करावे. इतर कोणत्याही व्यक्तीला किंवा त्यांच्या वैयक्तिक खात्यात पेमेंट करू नये. अशा प्रकारे केलेले पेमेंट कंपनीपर्यंत पोहोचले नाही, तर त्याची जबाबदारी कंपनी घेणार नाही.",

          "आयोजकांना योजना रद्द करण्याचा किंवा सहभाग नाकारण्याचा अधिकार आहे."
        ],
        more_info: "अधिक माहितीसाठी भेट द्या",

        our_gallery: "आमची गॅलरी",

        // Lottery form
        receiver_name: "प्राप्तकर्त्याचे नाव",
        receiver_coupon_no: "कूपन क्रमांक",
        receiver_address: "प्राप्तकर्त्याचा पत्ता",
        receiver_mobile: "प्राप्तकर्त्याचा मोबाईल",
        receiver_aadhaar: "प्राप्तकर्त्याचा आधार",
        giver_name: "प्रदानकर्त्याचे नाव",
        giver_mobile: "प्रदानकर्त्याचा मोबाईल",
        giver_address: "प्रदानकर्त्याचा पत्ता",
        payment_cash: "रोख देय",
        payment_online: "ऑनलाइन पेमेंट",
        submit: "सबमिट करा",
        registration_success: "नोंदणी यशस्वी!",
        registration_failed: "नोंदणी अयशस्वी",
      },
    },
  },

  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
